var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.1665V13.3332M3.33341 4.99984H16.6667L15.3501 16.8498C15.3049 17.2577 15.111 17.6345 14.8053 17.9082C14.4996 18.1819 14.1037 18.3332 13.6934 18.3332H6.30675C5.89644 18.3332 5.50055 18.1819 5.19487 17.9082C4.88919 17.6345 4.69521 17.2577 4.65008 16.8498L3.33341 4.99984ZM6.12091 2.62234C6.25571 2.33648 6.469 2.09483 6.73592 1.9256C7.00283 1.75636 7.31237 1.6665 7.62842 1.6665H12.3717C12.6879 1.66634 12.9976 1.75613 13.2647 1.92537C13.5318 2.09462 13.7452 2.33635 13.8801 2.62234L15.0001 4.99984H5.00008L6.12091 2.62234V2.62234ZM1.66675 4.99984H18.3334H1.66675ZM8.33342 9.1665V13.3332V9.1665Z",
    stroke: "#F3EDF3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.a393c0a337014d994d90098546bee989.svg";
export { ForwardRef as ReactComponent };